import { DragIndicator } from '@cheqroom/icons';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { cloneElement, createContext, FC, PropsWithChildren, ReactElement, useContext } from 'react';

import { theme } from '../../../../../tailwind.config';
import { Icon } from '../Icon/Icon';

interface SortableItemContextValue {
	dragHandleProps: DraggableProvidedDragHandleProps | null;
	isDragging: boolean;
}

export const SortableItemContext = createContext<SortableItemContextValue>({
	dragHandleProps: null,
	isDragging: false,
});

export const useSortableItem = () => useContext(SortableItemContext);

export const SortableItemHandle: FC<PropsWithChildren> = ({ children }) => {
	const { dragHandleProps } = useSortableItem();

	if (!children) {
		return (
			<div {...dragHandleProps}>
				<Icon source={DragIndicator} size="small" color={theme.colors.gray[300]} />
			</div>
		);
	}

	return cloneElement(children as ReactElement, { ...dragHandleProps });
};
